module.exports = __webpack_public_path__ + "static/media/roster.41f1a1ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/introduction/assets/roster.jpg
// module id = 205
// module chunks = 0